import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactPlaceholder from 'react-placeholder';
import { toast } from 'react-toastify';
import Controllers from '../../Api/Controllers';
import { FormCustom, Select } from '../../Components/Form/Form';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Helpers from '../../Components/Helpers/Helpers';

const CampamentoLideres = () => {
    const [ready, setReady] = useState(false)
    const [isProcessing, setIsProcessing] = useState(false)
    const [periodSelected, setPeriodSelected] = useState('')
    const [periods, setPeriods] = useState([])
    const [leaders, setLeaders] = useState([])

    const [modalShow, setModalShow] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [detailRows, setDetailRows] = useState([])

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriods(res.data)
            setReady(true)
        })
    }, [])

    const handleSubmit = () => {
        setIsProcessing(true)
        Controllers.customers.get_leaders_with_total_qty({
            p_id_period: periodSelected
        }).then(res => {
            setLeaders(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => setIsProcessing(false))
    }

    const handleCloseModal = () => {
        setModalShow(false)
        setDetailRows([])
    }

    const dtLeaders = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'leader_id', text: 'ID Líder', align: 'center' },
                { name: 'full_name_leader', text: 'Líder', align: 'center' },
                // { name: 'total_qty', text: 'Total Compras', align: 'center' },
                { name: 'total_points', text: 'Total Puntos', align: 'center' },
                {
                    name: 'actions',
                    text: 'Acciones',
                    align: 'center',
                    render: r => (
                        <Button size="sm" variant="info" onClick={() => {
                            setModalShow(true)
                            setModalTitle(`Referidos del Líder #${r.leader_id}`)
                            setDetailRows([])

                            Controllers.customers.get_referred_by_leader({
                                p_id_period: periodSelected,
                                p_id_customers: r.leader_id
                            }).then(res => {
                                setDetailRows(res.data)
                            }).catch(req => Helpers.promise.catch({ req, toast }))
                        }}>
                            Ver Detalle
                        </Button>
                    )
                }
            ]
        ]}
        rows={leaders}
        isProcessing={isProcessing}
    />, [leaders, isProcessing, periodSelected])

    const dtDetails = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'referred_id', text: 'ID Referido', align: 'center' },
                { name: 'full_name_referred', text: 'Nombre Referido', align: 'center' },
                { name: 'referred_date_registration', text: 'Fecha Registro' },
                { name: 'referred_document', text: 'Documento' },
                { name: 'key_product', text: 'Clave Producto' },
                { name: 'name_product', text: 'Producto' },
                { name: 'qty', text: 'Cantidad', align: 'center' }
            ]
        ]}
        rows={detailRows}
    />, [detailRows])

    return (
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={8}>
            <Card>
                <Card.Header className="justify-content-between">
                    <span>Campamento de Líderes</span>
                </Card.Header>
                <Card.Body>
                    <FormCustom viewSubmit={false}>
                        <Select
                            text="Período"
                            classNameParent="col-12 mb-3"
                            options={periods.map(p => ({
                                label: p.name_period,
                                value: p.id_period
                            }))}
                            onChange={e => setPeriodSelected(e.value)}
                            append={[
                                <Button onClick={handleSubmit}>
                                    <i className="fa fa-search mr-2"></i>Buscar
                                </Button>
                            ]}
                        />
                    </FormCustom>

                    {dtLeaders}
                </Card.Body>
            </Card>

            <Modal size="xl" show={modalShow} onHide={handleCloseModal} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title as="div">{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {dtDetails}
                </Modal.Body>
            </Modal>
        </ReactPlaceholder>
    )
}

export default CampamentoLideres
